import type {
  ProductPriceTierUpdateRequestType,
  ProductPriceTierUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

/** @deprecated Use useProductPriceListUpdate for the canonical PriceList contract. */
export const useProductPriceTierUpdate = (productPriceTierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductPriceTierUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `product-price-tiers/${productPriceTierId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as ProductPriceTierUpdateResponseType,
      ),
    onSettled: (response) => {
      if (response) {
        queryClient.invalidateQueries({
          queryKey: [
            business?.id,
            ServerStateKeys.Products,
            response.ProductId,
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
        });
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.PriceTiers],
        });
      }
    },
  });
};
